// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__4fg-M","container":"Privacy_container__+SPpx","title":"Privacy_title__lKvaD","subtitle":"Privacy_subtitle__g+t-w","text":"Privacy_text__084r+"};